import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { decodedJWT, getOwnerType } from "../utils/commonUtils";
import GridCellButtonWrapper from "../components/baseComponents/gridCellButtonWrapper";
import RoleManagement from "../security/roleManagement";
import User from "../interfaces/user";

const token = decodedJWT();

const getUserColDef: (onUsernameClick?: (userRow: User) => void) => GridColDef[] = onUsernameClick => [
  {
    field: 'username',
    headerName: 'Username',
    width: 150,
    renderCell: onUsernameClick ? (
      (params: GridRenderCellParams<User, any, any>) => {
        return (
          <GridCellButtonWrapper
            onClick={() => onUsernameClick(params.row)}
            text={params.row.username}
          />
        );
      }
    ) : undefined
  },
  { field: 'status', headerName: 'Status', width: 200 },
  { field: 'user_role', headerName: 'User Role', width: 150 },
  { field: 'name', headerName: 'Name', width: 200 },
  { field: 'owner_type', headerName: 'Owner Type', width: 100 },
  { field: 'owner_name', headerName: 'Owner Name', width: 150 },
  { field: 'phone_number', headerName: 'Phone Number', width: 150 },
  { field: 'email', headerName: 'Email', width: 250 },
  { field: 'address', headerName: 'Address', width: 300 },
  { field: 'is_temporarily_locked', headerName: 'Temporarily Locked', width: 150 },
  { field: 'last_password_updated_date', headerName: 'Last Password Updated On', width: 250 },
  { field: 'created_date', headerName: 'Created Date', width: 300 },
  { field: 'created_by', headerName: 'Created By', width: 300 },
  // only include Parent if owner_type is Client
  ...(token && RoleManagement.isClient(getOwnerType(token))
    ? [{ field: 'parent_username', headerName: 'Parent', width: 300 }]
    : []
  ),
];

export default getUserColDef;